/**
 * "+ 항목 추가/행 추가/사진 선택" 버튼 결 — leaf 모듈(의존 0).
 *
 * 원래 RowsCollectionEditor가 소유했으나, PhotoUploadWidget 분리(photoUploadWidget.tsx —
 * 2026-09-07 행 그리드 photo 위젯 도입) 시 RowsCollectionEditor ↔ photoUploadWidget 순환을
 * 피하려고 leaf로 내렸다. 기존 import 경로 호환은 RowsCollectionEditor의 re-export가 유지한다.
 *
 * 시안(remote-files/safetyhub_안전관리상태보고서.html) .add-item-btn — brand-200 점선 테두리 ·
 * brand-700 글자 · radius 8 · 패딩 7/16 · 13px/700 · 투명 바탕. 모양은 인라인이 소유하고
 * (rc Tailwind purge 규약) hover 면만 클래스로 얹는다.
 */
import type { CSSProperties } from 'react';

export const addItemButtonStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 5,
  padding: '7px 16px',
  borderRadius: 8,
  border: '1px dashed #c7d2fe',
  backgroundColor: 'transparent',
  color: '#4338ca',
  fontSize: 13,
  fontWeight: 700,
  cursor: 'pointer',
};

/**
 * rowLimit 도달로 비활성인 "+ 행 추가" 버튼의 어포던스 — 숨기지 않고 흐리게 남긴다
 * (왜 못 넣는지 title이 설명한다 — blocking-without-a-fix-path 계열 규약).
 */
export const addItemButtonDisabledStyle: CSSProperties = {
  opacity: 0.45,
  cursor: 'not-allowed',
};
